import type { LandingChromeConfig } from "@furistic/sdk-fe-ui-landing";

/**
 * Furistic platform identity for the shared landing chrome (navbar + footer).
 * Structure lives in `@furistic/sdk-fe-ui-landing`; identity lives here.
 * The wordmark leads with the Furistic mark (same geometry as
 * /favicon.svg) and keeps the violet dot of the old `Navbar.tsx`/`Footer.tsx`;
 * the anchor links (`#products`, `#platform`, `#developers`, `#contact`) only
 * exist on the home page, so they are home links with hash — react-router
 * preserves the hash and the browser scrolls.
 */
export const chrome: LandingChromeConfig = {
  brand: {
    name: "Furistic",
    dotClassName: "text-violet-400",
    icon: (
      <svg
        aria-hidden="true"
        viewBox="0 0 692 692.34"
        className="w-6 h-6 fill-indigo-500"
      >
        <path d="M497.2,254.61,105.74,280,58.61,692.34,91.51,72.06,497.2,254.61M0,253.17l497.2,1.44L39.79,156.85,58.61,692.34" />
        <path d="M194.8,437.72l391.46-25.35L633.39,0l-32.9,620.28L194.8,437.72M692,439.17l-497.2-1.45,457.41,97.77L633.39,0" />
      </svg>
    ),
  },
  navLinks: [
    { href: "/#products", label: "Products" },
    { href: "/#platform", label: "Platform" },
    { href: "/#developers", label: "Developers" },
  ],
  loginHref: "https://accounts.furistic.co",
  cta: {
    href: "/#contact",
    label: "Get Started",
  },
  ctaClassName: "bg-violet-600 hover:bg-violet-700 shadow-violet-600/30",
  tagline:
    "AI-powered operating systems for industries that move fast. Real estate, trading, standards audits, waste services, restaurants.",
  footerColumns: [
    {
      title: "Products",
      links: [
        { href: "/#products", label: "RealtyOS" },
        { href: "/#products", label: "TradeOS" },
        { href: "/#products", label: "ConformOS" },
        { href: "/#products", label: "Haulyard" },
        { href: "/#products", label: "Foodium" },
      ],
    },
    {
      title: "Platform",
      links: [
        { href: "/#platform", label: "AI Engine & Otto" },
        { href: "/#developers", label: "Developer API" },
      ],
    },
    {
      title: "Legal",
      links: [
        { href: "/legal/terms", label: "Terms of Service" },
        { href: "/legal/privacy", label: "Privacy Policy" },
        { href: "/legal/disclaimer", label: "AI Disclaimer" },
        { href: "/legal/security", label: "Security" },
        { href: "/legal/accessibility", label: "Accessibility" },
      ],
    },
  ],
  footerNotes: ["© 2026 Furistic Technologies Inc. All rights reserved."],
  accentClassName: "hover:text-violet-400",
};
